import sortIconUrl from './sortIcon.html';
export default {
  bindings: {
    model: '<',
    type: '@',
  },
  controllerAs: 'ctrl',
  controller() {
    this.isActive = () => this.model === this.type || this.model === `-${this.type}`;
  },
  templateUrl: sortIconUrl,
};
